import clsx from 'clsx';
import Header from 'components/header';
import warning from 'assets/images/warning.svg';
import styles from './styles.module.scss';

type ErrorMessageProps = {
  message: string;
  className?: string;
};

const ErrorMessage: React.FC<ErrorMessageProps> = (props) => {
  const { message, className } = props;

  return (
    <div className={clsx(styles.container, className)}>
      <img alt='Значок "!"' src={warning} width={60} height={60} />
      <Header text='Ошибка' />
      <div className={styles.message}>{message}</div>
    </div>
  );
};

export default ErrorMessage;
